/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailVm
 */
export interface UserDetailVm {
    /**
     * 
     * @type {string}
     * @memberof UserDetailVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailVm
     */
    familyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailVm
     */
    middlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailVm
     */
    forename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailVm
     */
    username?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailVm
     */
    isRegistered?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UserDetailVm
     */
    canRegisterUntil?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailVm
     */
    orgName?: string | null;
}

export function UserDetailVmFromJSON(json: any): UserDetailVm {
    return UserDetailVmFromJSONTyped(json, false);
}

export function UserDetailVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'familyname': !exists(json, 'familyname') ? undefined : json['familyname'],
        'middlename': !exists(json, 'middlename') ? undefined : json['middlename'],
        'forename': !exists(json, 'forename') ? undefined : json['forename'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'isRegistered': !exists(json, 'isRegistered') ? undefined : json['isRegistered'],
        'canRegisterUntil': !exists(json, 'canRegisterUntil') ? undefined : (json['canRegisterUntil'] === null ? null : new Date(json['canRegisterUntil'])),
        'orgName': !exists(json, 'orgName') ? undefined : json['orgName'],
    };
}

export function UserDetailVmToJSON(value?: UserDetailVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'familyname': value.familyname,
        'middlename': value.middlename,
        'forename': value.forename,
        'username': value.username,
        'isRegistered': value.isRegistered,
        'canRegisterUntil': value.canRegisterUntil === undefined ? undefined : (value.canRegisterUntil === null ? null : value.canRegisterUntil.toISOString()),
        'orgName': value.orgName,
    };
}


